import React from "react";
import { Tabs, Divider, Form } from "antd";
import { downloadImg } from "@/utils/constant";
import * as DICT from "@/utils/dict";
import CONST from "@/dataSource/CONST";
import defaultImg from "@/assets/images/pic-error.png";
import { ImageList } from "@/components/Img";
import BaseStatus from "./BaseStatus";
import intl from "react-intl-universal";
import styles from "./defaultStatus.module.less";
import PropIcon from "@/components/Icon/PropIcon";
import Icon from "@/components/Icon";
import http from "@/http";
import ReactResizeDetector from "react-resize-detector";

const { TabPane } = Tabs;
const HttpDevice = http.tokiot.device;
class DefaultStatus extends React.Component {
  state = {
    deviceInfo: {},
  };

  componentDidMount() {
    this.getDeviceInfo();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.refreshKey != this.props.refreshKey) {
      this.getDeviceInfo();
    }
  }

  getDeviceInfo = () => {
    const { deviceInfo } = this.props;
    if (deviceInfo && deviceInfo.id && deviceInfo.id.length > 0) {
      HttpDevice.get({
        id: deviceInfo.id,
        allShadowProp: true,
        groupShadowProp: true,
      }).then((ret) => {
        if (ret) {
          this.setState({ deviceInfo: ret });
        } else {
          this.setState({ deviceInfo: {} });
        }
      });
    }
  };

  showVedio = () => {
    const { deviceInfo } = this.state;
    const { sn, shadowProp, productId, name } = deviceInfo;
    if (!productId) return <React.Fragment />;
    let accessToken = "";
    let capacity = "";
    shadowProp &&
      shadowProp.forEach((item) => {
        if ("accessToken" === item.code) accessToken = item.value;
        if ("capacity" === item.code) capacity = item.value;
      });
    let playerType = "1278520532375302146" === productId ? "Flv" : "Yingshi";
    return (
      <React.Fragment>
        <Divider className={styles.dividerTitle} orientation="left">
          实时视频
        </Divider>
        <div className={styles.vedioDiv}>
          <ReactResizeDetector handleHeight>
            {({ width, height }) => {
              return (
                <div className={styles.vedio} style={{ height: width * 0.75 }}>
                  {/*<Player key={accessToken + sn} accessToken={accessToken} sn={sn} playerType={playerType} />*/}
                  <iframe
                    src={`/#/player/${JSON.stringify({
                      title: name,
                      sn,
                      accessToken,
                      playerType,
                      capacity,
                    })}`}
                  />
                </div>
              );
            }}
          </ReactResizeDetector>
        </div>
      </React.Fragment>
    );
  };

  render() {
    const { deviceInfo } = this.state;
    const { isVideo } = this.props;
    if (!(deviceInfo && deviceInfo.id && deviceInfo.id.length > 0)) return ``;
    let detail = deviceInfo;
    let shadowProp = [];
    if (detail && detail.shadowProp && detail.shadowProp.length > 0) {
      shadowProp = detail.shadowProp.filter((f1) => {
        if (detail.groupShadowProp && detail.groupShadowProp.length > 0) {
          let group = detail.groupShadowProp.find((f2) => {
            let data = Object.entries(f2);
            let name = ``;
            let value = [];
            if (data.length > 0 && data[0].length > 1) {
              name = data[0][0];
              value = data[0][1];
            }
            if (value.length > 0) {
              let findValue = value.find((v1) => v1.code === f1.code);
              return findValue;
            }
            return false;
          });
          if (group) {
            return false;
          }
        }
        return true;
      });
    }

    let getRow = (v) => {
      return (
        <div key={v.code}>
          <div className={styles.param_item}>
            <div title={v.name} className={styles.param_label}>
              <Icon.Wx type={v.icon} /> {v.name}
            </div>
            <div className={styles.param_value}>
              {v.value === null
                ? "-"
                : v.unit === null
                ? v.value
                : v.value + v.unit}
            </div>
          </div>
          <Divider className={styles.divider} />
        </div>
      );
    };
    return (
      <div className={styles.deviceInfoMain}>
        {isVideo && this.showVedio()}
        <BaseStatus deviceInfo={detail} />
        <Tabs className={styles.tabs} defaultActiveKey={`0`}>
          {detail && detail.groupShadowProp && detail.groupShadowProp.length > 0
            ? detail.groupShadowProp.map((v, index) => {
                let data = Object.entries(v);
                let name = ``;
                let value = [];
                if (data.length > 0 && data[0].length > 1) {
                  name = data[0][0];
                  value = data[0][1];
                }
                if (value.length > 0) {
                  return (
                    <TabPane className={styles.tabPane} tab={name} key={index}>
                      <div className={styles.param_list}>
                        {value.map((v1) => getRow(v1))}
                      </div>
                    </TabPane>
                  );
                }
              })
            : ""}
          <TabPane className={styles.tabPane} tab={`其他`} key={`other`}>
            <div className={styles.param_list}>
              {shadowProp && shadowProp.length > 0
                ? shadowProp.map((v) => getRow(v))
                : ""}
            </div>
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default DefaultStatus;
